import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';  // 引入 CommonModule
import { RouterModule } from '@angular/router';  // 引入 RouterModule
import { EnvironmentService } from '../../services/enviroment.service';
import { environment } from '../../services/global-environment';

@Component({
  selector: 'app-layout-center-toolbar',
  standalone: true,
  imports: [CommonModule,RouterModule],  // 只需導入模組，不需要導入服務
  templateUrl: './layout-center-toolbar.component.html',
  styleUrl: './layout-center-toolbar.component.scss'
})
export class LayoutCenterToolbarComponent {

}
